import { AuthContextProps, hasAuthParams } from 'react-oidc-context';
import { redirect } from 'react-router-dom';
import Routes from 'shared/enums/routes';

const authGuard = (auth: AuthContextProps) =>
  !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasAuthParams() ? redirect(Routes.Login) : null;

export default authGuard;
